<template>
  <section class="md-card cal-hoy">
    <div class="md-card__head">
      <h5><i class="bi bi-calendar-event"></i>Agenda de hoy</h5>
      <div v-if="estado.conectado" class="cal-acciones">
        <span class="md-pill">{{ visibles.length }}</span>
        <button type="button" class="btn btn-sm btn-link p-0" title="Nuevo evento" @click="abrirForm()">
          <i class="bi bi-plus-lg"></i>
        </button>
        <button type="button" class="btn btn-sm btn-link p-0" title="Elegir calendarios" @click="alternarSelector">
          <i class="bi bi-sliders"></i>
        </button>
        <button type="button" class="btn btn-sm btn-link p-0" title="Actualizar" :disabled="cargando" @click="cargar">
          <span v-if="cargando" class="spinner-border spinner-border-sm"></span>
          <i v-else class="bi bi-arrow-clockwise"></i>
        </button>
      </div>
    </div>

    <div v-if="aviso" class="alert py-2 small" :class="aviso.tipo === 'ok' ? 'alert-success' : 'alert-warning'">{{ aviso.texto }}</div>

    <div v-if="!estado.cargado" class="md-actualizando"><span class="spinner-border spinner-border-sm"></span> Cargando agenda…</div>

    <div v-else-if="!estado.conectado" class="md-empty">
      <i class="bi bi-plug"></i>
      <p v-if="!estado.configurado" class="mb-0">Google Calendar no está configurado en el servidor (faltan las credenciales de Google).</p>
      <template v-else>
        <p class="mb-2">Conecta Google Calendar para ver y gestionar aquí tus eventos de hoy.</p>
        <button class="btn btn-primary btn-sm" :disabled="conectando" @click="conectar">
          <span v-if="conectando" class="spinner-border spinner-border-sm me-1"></span>Conectar Google Calendar
        </button>
      </template>
    </div>

    <template v-else>
      <!-- Selector de calendarios -->
      <div v-if="selector" class="cal-panel">
        <div class="fw-semibold small mb-2">Calendarios a mostrar</div>
        <div v-if="!calendarios.length" class="md-vacio">Cargando…</div>
        <label v-for="c in calendarios" :key="c.id" class="cal-check">
          <input v-model="elegidos" type="checkbox" :value="c.id" />
          <span class="cal-dot" :style="{ background: c.backgroundColor || '#999' }"></span>
          {{ c.summary }}<small v-if="!c.editable" class="text-muted"> · solo lectura</small>
        </label>
        <div class="d-flex gap-2 mt-2">
          <button class="btn btn-primary btn-sm" :disabled="guardando" @click="guardarSeleccion">Guardar</button>
          <button class="btn btn-outline-secondary btn-sm" @click="selector = false">Cerrar</button>
          <button class="btn btn-link btn-sm text-danger ms-auto" @click="desconectar">Desconectar</button>
        </div>
      </div>

      <!-- Formulario de evento -->
      <form v-if="form" class="cal-panel" @submit.prevent="guardarEvento">
        <div class="fw-semibold small mb-2">{{ form.id ? 'Editar evento' : 'Nuevo evento' }}</div>
        <input v-model="form.titulo" class="form-control form-control-sm mb-2" placeholder="Título" required maxlength="200" />
        <select v-if="!form.id" v-model="form.calendarId" class="form-select form-select-sm mb-2" required>
          <option v-for="c in calendariosEditables" :key="c.id" :value="c.id">{{ c.summary }}</option>
        </select>
        <div class="row g-2 mb-2 align-items-center">
          <div class="col-12 col-sm-5">
            <input v-model="form.fecha" type="date" class="form-control form-control-sm" required />
          </div>
          <template v-if="!form.todoElDia">
            <div class="col-6 col-sm-3"><input v-model="form.horaInicio" type="time" class="form-control form-control-sm" required /></div>
            <div class="col-6 col-sm-3"><input v-model="form.horaFin" type="time" class="form-control form-control-sm" required /></div>
          </template>
        </div>
        <div class="form-check mb-2">
          <input id="cal-todo" v-model="form.todoElDia" type="checkbox" class="form-check-input" />
          <label for="cal-todo" class="form-check-label small">Todo el día</label>
        </div>
        <input v-model="form.lugar" class="form-control form-control-sm mb-2" placeholder="Lugar (opcional)" maxlength="300" />
        <textarea v-model="form.descripcion" class="form-control form-control-sm mb-2" rows="2" placeholder="Descripción (opcional)"></textarea>
        <div class="d-flex gap-2">
          <button class="btn btn-primary btn-sm" type="submit" :disabled="guardando">
            <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>Guardar
          </button>
          <button class="btn btn-outline-secondary btn-sm" type="button" @click="form = null">Cancelar</button>
        </div>
      </form>

      <div v-if="errores.length" class="alert alert-warning py-2 small">
        <div v-for="e in errores" :key="e">{{ e }}</div>
      </div>

      <p v-if="!eventos.length" class="md-vacio">Sin eventos hoy.</p>
      <p v-else-if="!visibles.length" class="md-vacio">Nada más por hoy.</p>
      <ul v-if="visibles.length" class="md-lista">
        <li
          v-for="e in visibles"
          :key="e.calendarId + e.id"
          class="md-evento cal-evento"
          :class="{ 'cal-evento--oculto': estaOculto(e) || haPasado(e) }"
        >
          <span class="md-evento__hora">{{ e.todoElDia ? 'Todo el día' : e.hora }}</span>
          <span class="cal-evento__cuerpo">
            <span class="cal-dot" :style="{ background: e.color || '#999' }" :title="e.calendario"></span>
            <a v-if="e.enlace" :href="e.enlace" target="_blank" rel="noopener noreferrer" class="cal-titulo">{{ e.titulo }}</a>
            <span v-else>{{ e.titulo }}</span>
            <small v-if="e.lugar" class="text-muted"> · {{ e.lugar }}</small>
            <a v-if="e.meet" :href="e.meet" target="_blank" rel="noopener noreferrer" class="ms-1" title="Unirse a Meet">
              <i class="bi bi-camera-video"></i>
            </a>
          </span>
          <span class="cal-evento__acciones">
            <button
              v-if="estaOculto(e)"
              type="button"
              class="btn btn-sm btn-link p-0"
              title="Volver a mostrar"
              @click="mostrarEvento(e)"
            >
              <i class="bi bi-eye"></i>
            </button>
            <button v-else type="button" class="btn btn-sm btn-link p-0" title="Ocultar evento" @click="ocultarEvento(e)">
              <i class="bi bi-eye-slash"></i>
            </button>
            <template v-if="e.editable && estado.puedeEscribir">
            <button type="button" class="btn btn-sm btn-link p-0" title="Editar" @click="abrirForm(e)"><i class="bi bi-pencil"></i></button>
            <button
              type="button"
              class="btn btn-sm btn-link text-danger p-0"
              title="Eliminar"
              :disabled="borrando === e.id"
              @click="borrar(e)"
            >
              <i class="bi bi-trash"></i>
            </button>
            </template>
          </span>
        </li>
      </ul>
      <button v-if="ocultosCount" type="button" class="btn btn-sm btn-link p-0 cal-toggle" @click="verOcultos = !verOcultos">
        <i class="bi" :class="verOcultos ? 'bi-eye-slash' : 'bi-eye'"></i>
        {{ verOcultos ? 'Ocultar' : 'Mostrar' }} {{ ocultosCount }} {{ ocultosCount === 1 ? 'evento oculto o pasado' : 'eventos ocultos o pasados' }}
      </button>
    </template>
  </section>
</template>

<script>
import {
  computed, onBeforeUnmount, onMounted, reactive, ref,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from '../config/axios';
import {
  leerCacheLocal, guardarCacheLocal, CLAVE_CACHE_AGENDA, hoyMadrid,
} from '../utils/miDia';

const hoyIso = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid' }).format(new Date());

const claveEvento = (e) => `${e.calendarId}|${e.id}`;

export default {
  name: 'CalendarioHoy',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const estado = reactive({
      cargado: false, configurado: true, conectado: false, puedeEscribir: false,
    });
    const eventos = ref([]);
    const errores = ref([]);
    const dia = ref(hoyIso());
    const calendarios = ref([]);
    const elegidos = ref([]);
    const selector = ref(false);
    const form = ref(null);
    const aviso = ref(null);
    const cargando = ref(false);
    const conectando = ref(false);
    const guardando = ref(false);
    const borrando = ref('');
    const ocultos = ref([]); // los guarda el servidor, así se ven igual en todos los dispositivos
    const verOcultos = ref(false);
    const ahora = ref(Date.now());
    let reloj = null;

    const calendariosEditables = computed(() => calendarios.value.filter((c) => c.editable));

    // Un evento con hora ya ha pasado cuando termina; los de todo el día no cuentan como pasados.
    const haPasado = (e) => !e.todoElDia && Date.parse(e.fin) < ahora.value;
    const estaOculto = (e) => ocultos.value.includes(claveEvento(e));
    const escondido = (e) => estaOculto(e) || haPasado(e);
    const ocultosCount = computed(() => eventos.value.filter(escondido).length);
    const visibles = computed(() => (verOcultos.value ? eventos.value : eventos.value.filter((e) => !escondido(e))));

    // Cambio inmediato en pantalla y después se guarda en el servidor; si falla, se deshace.
    async function fijarOculto(e, oculto) {
      const antes = ocultos.value;
      const clave = claveEvento(e);
      ocultos.value = oculto ? [...antes.filter((k) => k !== clave), clave] : antes.filter((k) => k !== clave);
      try {
        const { data } = await axios.put('/api/calendar/hidden', {
          calendarId: e.calendarId, eventId: e.id, oculto, dia: dia.value,
        });
        ocultos.value = data.ocultos || ocultos.value;
      } catch (err) {
        ocultos.value = antes;
        aviso.value = { tipo: 'error', texto: mensajeError(err, 'No se pudo guardar el cambio') };
      }
    }
    const ocultarEvento = (e) => fijarOculto(e, true);
    const mostrarEvento = (e) => fijarOculto(e, false);

    function mensajeError(e, defecto) {
      if (e.response?.data?.needsReauth) estado.conectado = false;
      return e.response?.data?.error || defecto;
    }

    async function cargarEstado() {
      try {
        const { data } = await axios.get('/api/calendar/status');
        Object.assign(estado, data);
      } catch (e) {
        aviso.value = { tipo: 'error', texto: mensajeError(e, 'No se pudo consultar Google Calendar') };
      } finally {
        estado.cargado = true;
      }
    }

    async function cargar() {
      if (!estado.conectado) return;
      cargando.value = true;
      try {
        const { data } = await axios.get('/api/calendar/events', { params: { dia: dia.value } });
        eventos.value = data.eventos || [];
        ocultos.value = data.ocultos || [];
        errores.value = data.errores || [];
        estado.puedeEscribir = data.puedeEscribir;
        guardarCacheLocal(CLAVE_CACHE_AGENDA, {
          dia: dia.value, eventos: eventos.value, ocultos: ocultos.value, errores: errores.value, puedeEscribir: !!data.puedeEscribir,
        });
      } catch (e) {
        if (e.response?.status === 409 || !eventos.value.length) eventos.value = [];
        aviso.value = { tipo: 'error', texto: mensajeError(e, 'No se pudo cargar la agenda') };
        if (e.response?.status === 409) estado.conectado = false;
      } finally {
        cargando.value = false;
      }
    }

    async function cargarCalendarios() {
      try {
        const { data } = await axios.get('/api/calendar/calendars');
        calendarios.value = data.calendarios || [];
        elegidos.value = calendarios.value.filter((c) => c.seleccionado).map((c) => c.id);
      } catch (e) {
        aviso.value = { tipo: 'error', texto: mensajeError(e, 'No se pudieron cargar los calendarios') };
      }
    }

    async function alternarSelector() {
      selector.value = !selector.value;
      if (selector.value) await cargarCalendarios();
    }

    async function guardarSeleccion() {
      guardando.value = true;
      try {
        await axios.put('/api/calendar/selection', { ids: elegidos.value });
        selector.value = false;
        await cargar();
      } catch (e) {
        aviso.value = { tipo: 'error', texto: mensajeError(e, 'No se pudo guardar la selección') };
      } finally {
        guardando.value = false;
      }
    }

    async function conectar() {
      conectando.value = true;
      try {
        const { data } = await axios.get('/api/calendar/oauth-url');
        window.location.href = data.url;
      } catch (e) {
        aviso.value = { tipo: 'error', texto: mensajeError(e, 'No se pudo iniciar la conexión') };
        conectando.value = false;
      }
    }

    async function desconectar() {
      if (!window.confirm('¿Desconectar Google Calendar?')) return;
      try {
        await axios.delete('/api/calendar');
        Object.assign(estado, { conectado: false, puedeEscribir: false });
        eventos.value = [];
        selector.value = false;
        form.value = null;
      } catch (e) {
        aviso.value = { tipo: 'error', texto: mensajeError(e, 'No se pudo desconectar') };
      }
    }

    async function abrirForm(ev) {
      aviso.value = null;
      if (!calendarios.value.length) await cargarCalendarios();
      if (ev) {
        const [ini = '09:00', fin = '10:00'] = (ev.hora || '').split('–');
        form.value = {
          id: ev.id,
          calendarId: ev.calendarId,
          titulo: ev.titulo,
          fecha: dia.value,
          todoElDia: ev.todoElDia,
          horaInicio: ini,
          horaFin: fin,
          lugar: ev.lugar,
          descripcion: ev.descripcion,
        };
      } else {
        const principal = calendariosEditables.value.find((c) => elegidos.value.includes(c.id))
          || calendariosEditables.value[0];
        form.value = {
          id: '',
          calendarId: principal?.id || '',
          titulo: '',
          fecha: dia.value,
          todoElDia: false,
          horaInicio: '09:00',
          horaFin: '10:00',
          lugar: '',
          descripcion: '',
        };
      }
    }

    async function guardarEvento() {
      const f = form.value;
      guardando.value = true;
      aviso.value = null;
      const cuerpo = {
        titulo: f.titulo,
        fecha: f.fecha,
        todoElDia: f.todoElDia,
        horaInicio: f.horaInicio,
        horaFin: f.horaFin,
        lugar: f.lugar,
        descripcion: f.descripcion,
      };
      try {
        if (f.id) await axios.put(`/api/calendar/events/${encodeURIComponent(f.calendarId)}/${encodeURIComponent(f.id)}`, cuerpo);
        else await axios.post('/api/calendar/events', { ...cuerpo, calendarId: f.calendarId });
        form.value = null;
        await cargar();
      } catch (e) {
        aviso.value = { tipo: 'error', texto: mensajeError(e, 'No se pudo guardar el evento') };
      } finally {
        guardando.value = false;
      }
    }

    async function borrar(ev) {
      if (!window.confirm(`¿Eliminar «${ev.titulo}»?`)) return;
      borrando.value = ev.id;
      try {
        await axios.delete(`/api/calendar/events/${encodeURIComponent(ev.calendarId)}/${encodeURIComponent(ev.id)}`);
        eventos.value = eventos.value.filter((x) => !(x.id === ev.id && x.calendarId === ev.calendarId));
      } catch (e) {
        aviso.value = { tipo: 'error', texto: mensajeError(e, 'No se pudo eliminar el evento') };
      } finally {
        borrando.value = '';
      }
    }

    onMounted(async () => {
      reloj = setInterval(() => { ahora.value = Date.now(); }, 60000);
      const resultado = route.query.calendar;
      if (resultado) {
        aviso.value = resultado === 'ok'
          ? { tipo: 'ok', texto: 'Google Calendar conectado.' }
          : { tipo: 'error', texto: String(route.query.message || 'No se pudo conectar Google Calendar') };
        router.replace({ query: {} });
      }
      // Con copia del mismo día se pinta al instante y estado + eventos se refrescan a la vez.
      const cache = leerCacheLocal(CLAVE_CACHE_AGENDA);
      if (cache && cache.dia === dia.value && dia.value === hoyMadrid()) {
        eventos.value = cache.eventos || [];
        ocultos.value = cache.ocultos || [];
        errores.value = cache.errores || [];
        Object.assign(estado, {
          cargado: true, configurado: true, conectado: true, puedeEscribir: !!cache.puedeEscribir,
        });
        await Promise.all([cargarEstado(), cargar()]);
        return;
      }
      await cargarEstado();
      await cargar();
    });

    onBeforeUnmount(() => clearInterval(reloj));

    return {
      visibles, ocultosCount, verOcultos, haPasado, estaOculto, ocultarEvento, mostrarEvento,
      estado, eventos, errores, calendarios, elegidos, selector, form, aviso, cargando, conectando, guardando, borrando,
      calendariosEditables, cargar, alternarSelector, guardarSeleccion, conectar, desconectar, abrirForm, guardarEvento, borrar,
    };
  },
};
</script>

<style scoped>
.md-card__head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.6rem; }
.md-card__head h5 { margin: 0; font-size: 1.05rem; font-weight: 700; display: flex; align-items: center; gap: 0.5rem; }
.md-card__head h5 i { color: var(--marca, #1f6b45); }
.md-pill { background: var(--marca-suave, rgba(31, 107, 69, 0.12)); color: var(--marca, #1f6b45); border-radius: 999px; padding: 0.1rem 0.6rem; font-weight: 600; font-size: 0.85rem; }
.md-vacio { color: var(--tinta-suave, #5c675e); margin: 0.25rem 0; font-size: 0.92rem; }
.md-empty { text-align: center; padding: 1rem 0.5rem; color: var(--tinta-suave, #5c675e); }
.md-empty i { font-size: 1.8rem; display: block; margin-bottom: 0.3rem; }
.md-lista { list-style: none; margin: 0; padding: 0; }
.md-evento { display: flex; gap: 0.8rem; padding: 0.4rem 0.3rem; }
.md-evento__hora { min-width: 5.2rem; color: var(--tinta-suave, #5c675e); font-variant-numeric: tabular-nums; }
.md-actualizando { font-size: 0.8rem; color: var(--tinta-suave, #5c675e); display: flex; align-items: center; gap: 0.4rem; }
.cal-acciones { display: flex; align-items: center; gap: 0.6rem; }
.cal-panel { background: rgba(0, 0, 0, 0.03); border-radius: 10px; padding: 0.75rem; margin-bottom: 0.75rem; }
.cal-check { display: flex; align-items: center; gap: 0.5rem; padding: 0.15rem 0; font-size: 0.92rem; cursor: pointer; }
.cal-dot { display: inline-block; width: 0.65rem; height: 0.65rem; border-radius: 50%; flex: none; }
.cal-evento { align-items: flex-start; }
.cal-evento__cuerpo { flex: 1; min-width: 0; display: flex; flex-wrap: wrap; align-items: center; gap: 0.35rem; }
.cal-evento__acciones { display: flex; gap: 0.6rem; flex: none; }
.cal-evento--oculto { opacity: 0.55; }
.cal-toggle { font-size: 0.82rem; margin-top: 0.4rem; }
.cal-titulo { color: inherit; text-decoration: none; }
.cal-titulo:hover { text-decoration: underline; }
</style>
